// extracted by mini-css-extract-plugin
export var logoIconSvg = "logoIcon-module--logoIconSvg--0d9c5";
export var logoIconWrapper = "logoIcon-module--logoIconWrapper--0fdf8";